/* Color Variants Bundle Script Code */

document.addEventListener('DOMContentLoaded', function () {
  const updateTriggerButton = (input) => {
    const modal = input.closest('.color-modal');
    const triggerId = modal.id.replace('color-modal', 'selected-color');
    const triggerButton = document.getElementById(triggerId);
    const selectedText = input.closest('label').textContent.trim();
    triggerButton.querySelector('.selected-color-text').textContent = selectedText;
  };

  // Open modal
  document.querySelectorAll('.color-option-trigger').forEach(button => {
    button.addEventListener('click', function () {
      const modal = document.getElementById(this.dataset.modalTarget);
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    });
  });

  // Close modal
  document.addEventListener('click', function (event) {
    if (event.target.matches('[data-modal-close]') || event.target.matches('.color-modal__overlay')) {
      const modalId = event.target.getAttribute('data-modal-close');
      document.getElementById(modalId).setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }
  });

  // Initialize - click first radio on page load
  document.querySelectorAll('.color-modal__content').forEach(content => {
    const firstRadio = content.querySelector('input[type="radio"]');
    if (firstRadio) firstRadio.click();
  });

  // Handle radio selection
  document.querySelectorAll('.color-modal__content input[type="radio"]').forEach(input => {
    input.addEventListener('change', function () {
      updateTriggerButton(this);
      const content = this.closest('.color-modal__content');
      content.querySelectorAll('label.selected').forEach(l => l.classList.remove('selected'));
      this.closest('label').classList.add('selected');
      const modal = this.closest('.color-modal');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    });
  });

  // Submit to cart
  window.submitColorProperties = function(submitButton) {
    const colorVariantsForm = document.getElementById("multi-color-options-form");
    let checkedInputs = colorVariantsForm.querySelectorAll('input[type="radio"]:checked');

    if (checkedInputs.length === 0) {
      console.error('No color selections made');
      return;
    }

    submitButton.classList.add("loading");

    const variantId = parseInt(colorVariantsForm.dataset.variantId);
    const parent_sku = colorVariantsForm.dataset.sku;
    const parent_price = parseFloat(colorVariantsForm.dataset.price) / 100;

    const itemProperties = {};
    const bundleProperties = { '_bundle_product1': `${parent_sku}/0/1` };
    
    let itemCounter = 1, bundleCounter = 2, total_price = 0, priceMarkUp = 0;
    
    checkedInputs.forEach(input => {
      total_price += parseInt(input.dataset.price);
    });

    checkedInputs.forEach((input, index) => {
      const itemPrice = parseInt(input.dataset.price);
      itemProperties[`_ITEM${itemCounter}`] = input.value;
      
      const proportional_price = parseFloat(((itemPrice / total_price) * parent_price).toFixed(2));
      priceMarkUp += proportional_price;
      const finalPrice = index === checkedInputs.length - 1 
        ? proportional_price + (parent_price - parseFloat(priceMarkUp.toFixed(2))) 
        : proportional_price;
      
      bundleProperties[`_bundle_product${bundleCounter}`] = `${input.dataset.sku}/${finalPrice}/1`;
      itemCounter++;
      bundleCounter++;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { ...itemProperties, ...bundleProperties } }],
        sections: document.body.classList.contains('cart-revamp') ? ["mini-cart-revamp", "cart-icon-bubble"] : ["mini-cart", "cart-icon-bubble"]
      })
    })
    .then(r => r.json())
    .then(data => {
      if (data.sections) {
        const cartSection = document.body.classList.contains('cart-revamp') ? 'mini-cart-revamp' : 'mini-cart';
        document.getElementById('mini-cart').innerHTML = data.sections[cartSection];
        document.getElementById('cart-icon-bubble').innerHTML = data.sections["cart-icon-bubble"];
      }
      document.querySelector(".cart-drawer-container")?.firstElementChild?.click();
      submitButton.classList.remove("loading");
    })
    .catch(error => {
      console.error('Error:', error);
      submitButton.classList.remove("loading");
    });
  };
});